<template>
  <div class="rightBaseModel">
    <div class="rightheader">
      <div class="title-box">
        <img src="@/assets/images/base.png" alt/>
        <span>训练基地</span>
        <div @click="gotobasemore" class="more">
          <span>更多</span>
          <i class="el-icon-caret-right"></i>
        </div>
      </div>
    </div>
    <div
      class="rightmetter"
      v-for="(item,index) in baseData"
      :key="index"
      @click="trainBase(item.id)"
    >
      <img :src="item.imgface" style="width:80px" />
      <div class="train-box">
        <span class="train-box-title" :title="item.basename">{{item.basename}}</span>
        <span class="train-box-text" :title="item.basetypename">级别：{{item.basetypename ? item.basetypename:'无'}}</span>
        <span class="train-box-text" :title="item.superiordeptname">所在部门：{{item.superiordeptname}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import * as trainApi from '@/api/train/index';

export default {
  data() {
    return {
      list: [],
      baseData: [],
      listQuery: {
        subType: null,
        subjectId: null,
        cateId: null,
        title: '',
        page: 1,
        limit: 10,
      },
    };
  },
  methods: {
    trainBase(Id) {
      this.$router.push({
        path: '/train/trainBase',
        query: {
          id: Id,
        },
      });
    },
    getbaseList() {
      trainApi.GetLoadTrainBase(this.listQuery).then((res) => {
        this.baseData = res.data;
      });
    },
    getList() {
      let para = {
        top: 20,
      };
      trainApi.getNewList(para).then((res) => {
        this.list = res.result;
      });
    },
    trainclass(id) {
      this.$router.push({
        path: '/train/trainclass',
        query: {
          id: id,
        },
      });
    },
    gotobasemore() {
      this.$router.push({
        path: '/train/Basemore',
      });
    },
  },
  created() {
    // this.getList();
    this.getbaseList();
  },
};
</script>
<style lang="scss" scoped>
.rightBaseModel{
  box-sizing: border-box;
  padding: 23px 15px;
  .rightheader {
    margin-bottom: 10px;
    .title-box {
      display: flex;
      align-items: center;
      &>img{
        width: 20px;
        height: auto;
        margin-right: 8px;
      }
      &>span{
        flex: 1;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #4D515A;
      }
      .more{
        cursor: pointer;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        color: #4C515B;

        &>span{
          margin-right: 5px;
        }
        &>i{
          color: #A7B1BC;
        }
      }
    }
  }
  .rightmetter {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 4px 8px;
    margin-bottom: 11px;

    &:hover{
      background-color: #ebeef5;
      border-radius: 2px;
    }

    &>img {
      flex-shrink: 0;
      width: 101px;
      height: 67px;
      margin-right: 18px;
    }

    .train-box {
      width: calc(100% - 101px);
      flex-shrink: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .train-box-title {
      font-size: 14px;
      font-weight: 700;
      line-height: 21px;
      color: #4D515A;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .train-box-text {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 18px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

</style>